import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import mutationEventsMiddleware from 'analytics/mutationEvents';
import sessionEventsMiddleware from 'analytics/sessionEvents';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import baseApi from 'services/api/baseApi';
import sessionMiddleware, { adopted } from 'services/session/sessionMiddleware';
import { readSession } from 'services/session/sessionStore';

import reducer from '../slices';
import { signInUser } from '../slices/user.slice';

const persistConfig = {
  key: 'root-lidz',
  storage,
  whitelist: ['theme', 'azureEnvironment'],
};

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(baseApi.middleware, sessionMiddleware, mutationEventsMiddleware, sessionEventsMiddleware),
});

setupListeners(store.dispatch);

const bootSession = readSession();
if (bootSession) store.dispatch(adopted(signInUser(bootSession)));

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof reducer>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = (dispatch: AppDispatch, getState: () => RootState) => void;
